import messageResource from "../messageResource";
import TemplateView from "../TemplateView"

export default class TypeOfWorkNode extends TemplateView {
    constructor({
        typeOfWork,
        selected,
        onClick = () => {},
        searchText
    }) {
        super();

        this.onClick = onClick

        this.params = {
            id: typeOfWork.id,
            name: typeOfWork.name,
            billable: typeOfWork.billable,
            active: typeOfWork.active,
            default: typeOfWork.default,
            selected: selected,
            searchText
        }
    }

    templateHtml() {
        return "<div class='typeOfWorkRow'>" +
               "    <div class='typeLabel ellipsis <%-archived%>'>" +
               "        <span class='searchText'><%-searchText%></span><%-name%> <%-defaultLabel%>" +
               "    </div>" +
               "    <span class='nonBillableLabel'><%-nonBillable%></span>" +
               "</div>"
    }

    templateModel() {
        return {
            name: this.params.name.substring(this.params.searchText.length),
            searchText: this.params.searchText,
            nonBillable: this.params.billable ? '' : messageResource.getMessage('billing_type.non_billable.lowercase'),
            archived: this.params.active ? '' : messageResource.getMessage('billing_type.archived'),
            defaultLabel: this.params.default ? messageResource.getMessage('billing_type.default') : ''
        }
    }

    afterRender() {
        this.$el.toggleClass('selected', this.params.selected)
        this.$el.click(() => this.onClick(this.params.id))
    }
}


// WEBPACK FOOTER //
// ./web/js/typesOfWork/TypeOfWorkNode.js